import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

/*
----------------------------------
RenderTooltip Component
----------------------------------
This Component renders the tooltips
----------------------------------
*/

const RenderTooltip = ({ value, label, tooltip }) => {
  return (
    <tr>
      <td>{label}</td>
      <td>
        {value}{' '}
        {tooltip.length ? (
          <>
            <i
              id={label.replaceAll(' ', '') + 'count'}
              className="fa fa-exclamation-circle"
            />
            <UncontrolledTooltip
              placement="top"
              target={label.replaceAll(' ', '') + 'count'}
            >
              <span dangerouslySetInnerHTML={{ __html: tooltip }}></span>
            </UncontrolledTooltip>
          </>
        ) : (
          ''
        )}
      </td>
    </tr>
  );
};

export default RenderTooltip;
